import { ArrowRight, Wrench } from "lucide-react";

export default function JoinRepairer() {
    return (
        <section
            id="join-repairer"
            data-testid="join-repairer-section"
            className="py-20 md:py-28 bg-carbon border-t border-white/5"
        >
            <div className="max-w-7xl mx-auto px-6 md:px-10">
                <div className="relative overflow-hidden rounded-3xl border border-white/10 bg-gradient-to-br from-white/[0.06] to-transparent p-10 md:p-16">
                    <div className="absolute -top-16 -right-16 w-64 h-64 rounded-full bg-safety/10 blur-3xl" />
                    <div className="relative max-w-2xl">
                        <div className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full border border-electric/30 bg-electric/5 mb-6">
                            <Wrench size={14} className="text-electric" />
                            <span className="uppercase text-xs tracking-[0.25em] text-electric">
                                For panel &amp; paint shops
                            </span>
                        </div>
                        <h2 className="font-display text-4xl md:text-5xl text-white font-bold leading-[1.05] tracking-tight">
                            Own a repair shop?{" "}
                            <em className="not-italic text-safety">
                                Get matched to local jobs.
                            </em>
                        </h2>
                        <p className="text-slate-400 mt-5 text-base leading-relaxed max-w-xl">
                            Join the Panel Pros network to receive customer leads
                            in your area, set your own labour, paint and parts
                            pricing, and run instant AI quotes tuned to your rates.
                        </p>
                        <a
                            href="/shops"
                            data-testid="join-repairer-cta"
                            className="group inline-flex items-center gap-2 mt-8 px-7 py-3.5 text-sm font-bold text-white bg-safety hover:bg-safety-dark transition-all hover:-translate-y-0.5 active:scale-95 shadow-glow-orange rounded-2xl"
                        >
                            Join as a Repairer
                            <ArrowRight
                                size={16}
                                className="transition-transform group-hover:translate-x-1"
                            />
                        </a>
                    </div>
                </div>
            </div>
        </section>
    );
}
